import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ka from './locales/ka.json';
import ru from './locales/ru.json';

const resources = {
  en: { translation: en },
  ka: { translation: ka },
  ru: { translation: ru },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'ka',
    fallbackLng: 'ka',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
